import * as React from 'react';
import styles from './cart.module.scss';
import Footer from '../../components/footer';
import { Table } from '../../components/table';
import Button from '../../components/button';
import { prices, checkoutUrl } from '../../utils';
import isMobile from 'is-mobile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const header = [
  {
    node: <p />,
  },
  {
    node: <p>Product</p>,
  },
  {
    node: <p>Price</p>,
  },
  {
    node: <p>Quantity</p>,
  },
  {
    node: <p>Total</p>,
  },
];

const rows = [
  [
    {
      node: (
        <img
          src="https://res.cloudinary.com/albin-groen/image/upload/f_auto,w_50,h_50/v1586101021/ceroface/whats-included.png"
          alt="Product"
        />
      ),
    },
    {
      node: <p><strong>Ceroface ALL-IN-ONE Kit</strong></p>,
    },
    {
      node: <p><strong>{prices.defaultDetailed}</strong></p>,
    },
    {
      node: <p><strong>1</strong></p>,
    },
    {
      node: <p><strong>{prices.defaultDetailed}</strong></p>,
    },
  ],
];

const Cart: React.FC = () => (
  <div className={styles.pageWrapper}>
    {isMobile() && (
      <Button href={checkoutUrl} style={{ marginBottom: '2rem', width: '100%' }} variant="cta">Proceed to checkout</Button>
    )}
    <Table rows={rows} header={header} />
    <Summary />
    <Footer />
  </div>
);

export const SummaryRow: React.FC<{ field: any, value: any | React.ReactNode }> = ({ field, value }) => (
  <div className={styles.summaryRow}>
    <p className={styles.summaryRowKey}>{field}</p>
    <p className={styles.summaryRowValue}>
      <strong>
        {value}
      </strong>
    </p>
  </div>
)

const Summary: React.FC = () => {
  return (
    <div className={styles.summaryWrapper}>
      <div className={styles.summaryContent}>
        <h1>Your cart</h1>  

        <div className={styles.summary}>
          <SummaryRow field="Subtotal" value={prices.defaultDetailed} />
          <SummaryRow 
            field="Shipping"
            value={
              <>
                <span>Free of charge</span>
                <FontAwesomeIcon icon={faCheck} style={{ color: '#00ba6d', marginLeft: '1rem' }} />
              </>
            }
           />
          <SummaryRow field="Total" value={prices.defaultDetailed} />
        </div>

        <Button href={checkoutUrl} variant="cta">Proceed to checkout</Button>
      </div>
    </div>
  )
}



export default Cart;
